var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescriptionPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 12.066,
    height: 12.066,
    viewBox: "0 0 12.066 12.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_142",
    "data-name": "Vrstva 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_158",
    fill: "#8b8c8c",
    d: "M8.219 14.413l6.193-6.193a2 2 0 0 0 0-2.821L12.53 3.516a2 2 0 0 0-2.821 0L3.515 9.71a2 2 0 0 0-.585 1.41V15h3.878a2 2 0 0 0 1.41-.585zm-3.992-3.326a.665.665 0 0 1 .193-.466l6.2-6.2a.665.665 0 0 1 .938 0L13.441 6.3a.665.665 0 0 1 0 .938l-6.167 6.237a.665.665 0 0 1-.466.193H4.261z",
    "data-name": "Trazado 158",
    transform: "translate(-2.93 -2.933)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionPencil);
export default __webpack_public_path__ + "static/media/description-pencil.3626d496.svg";
export { ForwardRef as ReactComponent };